// extracted by mini-css-extract-plugin
export var giphy = "Giphy-module--giphy--2UMCp";